<script lang="ts" setup>
import MainPage from '@/pages/main';

definePageMeta({
  name: 'main',
});
</script>

<template>
  <MainPage />
</template>
